module.exports = __webpack_public_path__ + "img/abase.9bab8b5c.png";